/* eslint-disable global-require */
import React from 'react';
import styles from './css/ArticlesBlock.styl';
import ArticleButton from './ArticleButton';
import appConfig from '../../../../../appConfig/AppConfig';
import {FormControls} from '../../../../shared/library';
import CasketImg from './assets/casket.jpg';
import BurialImg from './assets/burial.jpg';
import SupportImg from './assets/support.jpg';

const {Button} = FormControls;
const domain = appConfig().vanityDomain;

const ArticlesBlock = () => {
  const handleClick = () => {
    if (window) {
      window.open(`${domain}/news/advice-and-support`, '_blank');
    }
  };

  return (
    <div className={styles.ArticlesBlock}>
      <h2 className={styles.Title}>End-of-Life Help</h2>
      <div className={styles.Articles}>
        <ArticleButton
          href={`${domain}/news/advice-and-support/article/how-to-shop-for-a-funeral-home`}
          image={CasketImg}
          title="How to Shop for a Funeral Home"
        />
        <ArticleButton
          href={`${domain}/news/advice-and-support/article/burial-vs-cremation-and-alternatives-pros-and-cons`}
          image={BurialImg}
          title="Burial vs. Cremation vs. Alternative Options"
        />
        <ArticleButton
          href={`${domain}/news/advice-and-support/article/what-to-do-when-a-loved-one-is-terminal`}
          image={SupportImg}
          title="What to Do When a Loved One Is Terminal"
        />
      </div>
      <Button className={styles.ArticlesButton} handleClick={handleClick}>
        View All Articles
      </Button>
    </div>
  );
};

export default ArticlesBlock;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Planning/components/ArticlesBlock/index.js